import { database } from './../../firebase/firebase-app';

const categoryRef = database.ref('sets').orderByChild('order');

import { listenToPicturesByIds } from './../pictures';

export const listenToSets = () => {
  return dispatch => {
    const setsPictruresIds = [];
    categoryRef.off();
    categoryRef.once("value")
      .then( snapshot => {
        let res = {};
        snapshot.forEach( childSnapshot => {
          var key = childSnapshot.key;
          var childData = childSnapshot.val();
          res[key] = childData;
          try {
            childData.photo && !setsPictruresIds.includes(childData.photo[0]) && setsPictruresIds.push(childData.photo[0]);
          } catch (e) {
            console.log(e);
          }
        });
        return res;
      })
      .then( res => {
        dispatch({
          type: 'RECEIVE_SETS',
          payload: res
        });
        dispatch({
          type: 'SET_LOADING',
          p: { sets: true }
        });
        // receive all sets main pictures
        dispatch(listenToPicturesByIds(setsPictruresIds, 'sets main pictures'));
      })
      .catch( error => {
          dispatch({
            type: 'RECEIVE_SETS_ERROR',
            payload: error.message
          });
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/firebase/sets.js